import React from 'react';

const ProgressBar = ({ completed }) => {
  const numPixels = completed === 0 ? '1%' : `${(completed / 100) * 150}px`;

  return (
    <div className="create-job-posting__progress-section" data-testid="pro-tip-progress-bar">
      <div className="create-job-posting__progress-bar-container">
        <div style={{ width: numPixels }} className="create-job-posting__progress-bar" />
        <div
          className="create-job-posting__percentage-label"
          data-testid="job-posting-percentage-label"
        >
          {completed}%
        </div>
      </div>
      <p className="create-job-posting__progress-label">Job Posting Completion Tracker</p>
    </div>
  );
};

export default ProgressBar;